import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { CustomParameter } from '@app/core/store/custom-parameter/custom-parameter.type';

export const customParameterActions = createActionGroup({
  source: '[Custom Parameter]',
  events: {
    loadCustomParameters: emptyProps(),
    loadCustomParametersSuccess: props<{ parameters: CustomParameter[] }>(),
    loadCustomParametersFailure: props<{ error: string }>()
  }
});
